import { getHomepage } from 'utils/routes';

export const appHomeSelector = () => getHomepage();
